// VARIABLE_CLASSROOMS_V1

export function classroomDayName(
  dateValue
) {
  if (!dateValue) {
    return '';
  }

  const parts =
    String(dateValue)
      .slice(0, 10)
      .split('-')
      .map(Number);

  if (
    parts.length !== 3 ||
    !parts.every(Number.isFinite)
  ) {
    return '';
  }

  return new Date(
    parts[0],
    parts[1] - 1,
    parts[2],
    12,
    0,
    0
  ).toLocaleDateString(
    'en-GB',
    {
      weekday: 'long'
    }
  );
}


export function normalClassroomForDate(
  course,
  dateValue
) {
  const day =
    classroomDayName(
      dateValue
    );

  if (!day) {
    return '';
  }

  const rooms =
    course?.classrooms;

  if (
    rooms &&
    typeof rooms === 'object' &&
    !Array.isArray(rooms)
  ) {
    return String(
      rooms[day] ||
      rooms[day.toLowerCase()] ||
      ''
    ).trim();
  }

  if (
    typeof rooms === 'string'
  ) {
    return rooms.trim();
  }

  return '';
}


export function effectiveClassroomForWeek(
  course,
  week,
  groupClassroomOverride = null
) {
  const normal =
    normalClassroomForDate(
      course,
      week?.class_date
    );

  if (
    course?.variable_rooms_enabled !==
    true
  ) {
    return normal;
  }

  const groupRoom =
    String(
      groupClassroomOverride ||
      ''
    ).trim();

  if (groupRoom) {
    return groupRoom;
  }

  const weekRoom =
    String(
      week?.classroom_override ||
      ''
    ).trim();

  if (weekRoom) {
    return weekRoom;
  }

  return normal;
}
